import request from '../utils/request';
//班级项目分类
export function getProjectCodeList(data) {
  return request({
    url: 'webIndex/getProjectCodeList.html',
    method: 'post',
    data
  });
}

//根据分类获取班级列表
export function getClassList(data) {
  return request({
    url: '/webIndex/toCourseList.html',
    method: 'post',
    data
  });
}

//获取班级详情
export function getClassDetail(data) {
  return request({
    url: '/project/getClassDetail.html',
    method: 'post',
    data
  });
}

//获取班级课程列表
export function getClassCourseList(data) {
  return request({
    url: '/project/getClassCourseList.html',
    method: 'post',
    data
  });
}

//获取热门班级列表
export function getHotClassList(data) {
  return request({
    url: '/project/getHotClassList.html',
    method: 'post',
    data
  });
}

//获取课程详情
export function getCourseInfo(data) {
  return request({
    url: '/resource/course/getCourseInfoNew.html',
    method: 'post',
    data
  });
}

//获取视频地址
export function getCourseVideoUrl(data) {
  return request({
    url: '/resource/course/getCourseVideoUrl.html',
    method: 'post',
    data
  });
}

//加入课程名单
export function addUserCourse(data) {
  return request({
    url: 'userCourse/addUserCourse.html',
    method: 'post',
    data
  });
}

//获取用户选择课程数量
export function getUserCourseCount() {
  return request({
    url: 'userCourse/getUserCourseCount.html',
    method: 'get',
  });
}

//获取用户课程列表
export function getUserCourseList(data) {
  return request({
    url: 'userCourse/getUserCourseList.html',
    method: 'get',
    params:data
  });
}

//删除课程
export function removeUserCourse(data) {
  return request({
    url: 'userCourse/removeUserCourse.html',
    method: 'post',
    data
  });
}

//导出数据
export function exportUserCourseCw(data) {
  return request({
    url: 'resource/course/exportUserCourseSimple.html',
    method: 'post',
    responseType: 'blob',
    data
  });
}